
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import { DispatchBoardSearch } from '../models/DispatchBoardSearch';
import * as _ from 'lodash';
import { v_EmployeeSearchBus } from '../models/v_EmployeeSearchBus';
import { CommonParam } from '../models/CommonParam';
import { PayrollMaintParam } from '../models/PayrollMaintParam';
import { PayrollMaintBus } from '../models/PayrollMaintBus';
import { of } from 'rxjs';
import { LockPayweekParam } from '../models/lockPayweekParam';
import { UnionBenefitsInputParamBus } from '../models/UnionBenefitsInputParamBus';
import { ExpenseSummaryFilterBus } from '../models/ExpenseSummaryFilterBus';
import { PayrollDeductionBus } from '../models/PayrollDeductionBus';
import { ExpenseMaintBus } from '../models/ExpenseMaintBus';
import { AttachmentBus } from '../models/AttachmentBus';
import { FileInfo } from '@progress/kendo-angular-upload';
import { UnionTimeTypeBenefitExclusionInputParamBus } from '../models/UnionTimeTypeBenefitExclusionInputParamBus';

@Injectable()
export class PayrollService extends BaseService {
    dispatchBaseUrl: string;
    vehicleBaseUrl: string;
    constructor(_http: HttpClient) {
        super(_http);
        this.baseUrl = this.rootUrl + "Payroll/";
        this.dispatchBaseUrl = this.rootUrl + "Dispatch/";
        this.vehicleBaseUrl = this.rootUrl + "Vehicle/";
    }
    getTimeDetail(param: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "GetTimeDetail";
        return this._http.get(url_call, options);
    }
    validateDispatchLaborOverLap(model: any): Observable<any> {
        let headers = this.getHeaders();
        let sModel = JSON.stringify(model);
        let options = this.getOptionsUL('', '', "model", sModel);
        let url_call: string = this.dispatchBaseUrl + "ValidateDispatchLaborOverLap";
        return this._http.put(url_call, model, { headers });
    }
    getTimeForApproval(param: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "GetTimeForApproval";
        return this._http.get(url_call, options);
    }
    getTimeDetailNotApproved(param: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "GetTimeDetailNotApproved";
        return this._http.get(url_call, options);
    }
    timeSheetApprovalSaveAll(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "TimeSheetApprovalSaveAll";
        return this._http.put(url_call, model, { headers });
    }

    getExpenseSummary(param: ExpenseSummaryFilterBus): Observable<any> {
        let headers = this.getHeaders();
        let payrollMaintParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "payrollMaintParam", payrollMaintParam);
        let url_call: string = this.baseUrl + "GetExpenseSummary";
        return this._http.get(url_call, options);
    }

    getPayrollMaintAll(param: PayrollMaintParam): Observable<any> {
        let headers = this.getHeaders();
        let payrollMaintParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "payrollMaintParam", payrollMaintParam);
        let url_call: string = this.baseUrl + "GetPayrollMaintAll";
        return this._http.get(url_call, options);
    }

    getDocument(Id: string) {
        let url_call: string = this.dispatchBaseUrl + "GetDocumentByParentId/" + Id;
        return super.get(url_call); //, { headers: headers });
    }
    getDocumentVehicleMaint(Id: string) {
        let url_call: string = this.vehicleBaseUrl + "GetDocumentByParentId/" + Id;
        return super.get(url_call); //, { headers: headers });
    }
    getDocumentMiscEspense(Id: string) {
        let url_call: string = this.baseUrl + "GetDocumentByParentId/" + Id;
        return super.get(url_call); //, { headers: headers });
    }
    getPayrollMaintExportAll(param: PayrollMaintParam): Observable<any> {
        let headers = this.getHeaders();
        let payrollMaintParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "payrollMaintParam", payrollMaintParam);
        let url_call: string = this.baseUrl + "GetPayrollExportAll";
        return this._http.get(url_call, options);
    }
    getPayrollMaintExportNonApproved(param: PayrollMaintParam): Observable<any> {
        let headers = this.getHeaders();
        let payrollMaintParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "payrollMaintParam", payrollMaintParam);
        let url_call: string = this.baseUrl + "ExportPayrollNonApproved";
        return this._http.get(url_call, options);
    }
    getPayrollMaintExportAllNoExec(param: PayrollMaintParam): Observable<any> {
        let headers = this.getHeaders();
        let payrollMaintParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "payrollMaintParam", payrollMaintParam);
        let url_call: string = this.baseUrl + "GetPayrollExportAllNoExec";
        return this._http.get(url_call, options);
    }
    getPayrollExportOriginal(param: PayrollMaintParam): Observable<any> {
        let headers = this.getHeaders();
        let payrollMaintParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "payrollMaintParam", payrollMaintParam);
        let url_call: string = this.baseUrl + "GetPayrollExportOriginal";
        return this._http.get(url_call, options);
    }

    payrollMaintSaveAll(data: PayrollMaintBus): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "PayrollMaintSaveAll";
        return this._http.put(url_call, data, { headers });
    }
    expenseMaintSaveAll(data: ExpenseMaintBus): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "ExpenseMaintSaveAll";
        return this._http.put(url_call, data, { headers });
    }
    payrollDeductionAdd(data: PayrollDeductionBus): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "PayrollDeductionAdd";
        return this._http.put(url_call, data, { headers });
    }
    unionBenefitsSaveAll(data: UnionBenefitsInputParamBus): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "BenefitMappingSaveAll";
        return this._http.put(url_call, data, { headers });
    }
    timeExclusionSaveAll(data: UnionTimeTypeBenefitExclusionInputParamBus): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "TimeExclusionSaveAll";
        return this._http.put(url_call, data, { headers });
    }



    lockPayweek(data: LockPayweekParam): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "lockPayweek";
        return this._http.put(url_call, data, { headers });
    }
    getPayweekLock(): Observable<any> {
        let headers = this.getHeaders();
        var data = new LockPayweekParam()
        let url_call: string = this.baseUrl + "GetPayweekLock";
        return this._http.put(url_call, data, { headers });
    }
    getBenefitMapping(param: PayrollMaintParam): Observable<any> {
        let headers = this.getHeaders();
        let payrollMaintParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "payrollMaintParam", payrollMaintParam);
        let url_call: string = this.baseUrl + "getBenefitMapping";
        return this._http.get(url_call, options);
    }
    getTimeExclusions(param: PayrollMaintParam): Observable<any> {
        let headers = this.getHeaders();
        let payrollMaintParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "payrollMaintParam", payrollMaintParam);
        let url_call: string = this.baseUrl + "GetTimeExclusions";
        return this._http.get(url_call, options);
    }

    deleteUnionBenefitLine(id: any): Observable<any> {
        //let headers = this.getHeaders();
        //let url_call: string = this.baseUrl + "DeleteUnionBenefitLine/" + id;
        //return this._http.delete(url_call, { headers });
        console.log('deleting');
        return of(true);
    }

    importBenefitMapping(files: FileInfo[], data: AttachmentBus): Observable<any> {
        let url: string = this.baseUrl + "importBenifitMapping";
        let dataStr: string = JSON.stringify(data);
        // Init formData
        data.attachment = null;
        const formData = new FormData();

        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }
        formData.append("AttachmentData", dataStr);
        return this._http.put(url, formData);
    }

}
